<template>
  <main-layout>
    <div v-if="loading" class="my-4 text-xs-center">
      <v-progress-circular indeterminate color="primary" />
    </div>
    <template v-else>
      <v-tabs v-model="viewState" slider-color="primary">
        <v-tab v-if="trainingConfig && trainingConfig.auto_training == true" href="#auto-classify">
          <span>Auto Training</span>
        </v-tab>
        <v-tab href="#non-classify">
          <span>Non Classify</span>
        </v-tab>

        <v-tab v-if="selectedBot && selectedBot.type == 'nextcapital'" href="#setting">
          <span>Setting</span>
        </v-tab>
      </v-tabs>
      <component
        :is="viewState"
        :key="timestamp"
        :training-config="trainingConfig"
        @onSaveTrainingConfig="onSaveTrainingConfig"
      ></component>
    </template>
    <v-snackbar v-model="snackbar.show" :timeout="3000" :color="snackbar.color" :right="true">{{
      snackbar.message
    }}</v-snackbar>
  </main-layout>
</template>

<script>
import NonClassifyVue from './NonClassify/index.vue'
import AutoClassifyVue from './AutoClassify.vue'
import SettingVue from './Setting.vue'
import trainingApi from '@/api/training'
import { mapGetters } from 'vuex'
import { handleApiError } from '@/api/util'
import moment from 'moment'

export default {
  components: {
    'non-classify': NonClassifyVue,
    'auto-classify': AutoClassifyVue,
    setting: SettingVue
  },
  data() {
    return {
      viewState: 'auto-classify',
      trainingConfig: null,
      loading: true,
      snackbar: {
        show: false,
        message: '',
        color: 'green'
      },
      timestamp: moment().format('x')
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    this.loading = true
    await this.handleGetTrainingConfig()
    if (this.trainingConfig && this.trainingConfig.auto_training == true) {
      this.viewState = 'auto-classify'
    } else {
      this.viewState = 'non-classify'
    }
    this.loading = false
  },
  methods: {
    async onSaveTrainingConfig({ trainingConfig, onSuccess, onError }) {
      if (!trainingConfig) return false
      this.$store.dispatch('loading')
      const response = await trainingApi.putTrainingConfig({
        data: trainingConfig
      })
      if (response && response.status == 200) {
        if (onSuccess) {
          onSuccess()
        } else {
          this.snackbar.message = 'Successful'
          this.snackbar.color = 'green'
          this.snackbar.show = true
        }
        this.trainingConfig = trainingConfig
        await this.$nextTick()
        this.timestamp = moment().format('x')
      } else {
        if (onError) {
          onError()
        } else {
          this.snackbar.message = 'Unscuccessful'
          this.snackbar.color = 'red'
          this.snackbar.show = true
        }
      }
      this.$store.dispatch('clear_loading')
    },
    async handleGetTrainingConfig() {
      try {
        const response = await trainingApi.getTrainingConfig({
          config: {
            params: {
              page_id: this.selectedBot.pageid
            }
          }
        })
        if (response.status === 200 && response.data.data) {
          const data = response.data.data
          this.trainingConfig =
            data.length > 0
              ? {
                  ...data[0],
                  max_score:
                    typeof data[0].max_score == 'string'
                      ? parseFloat(data[0].max_score)
                      : this.maxScore,
                  min_score:
                    typeof data[0].min_score == 'string'
                      ? parseFloat(data[0].min_score)
                      : this.minScore,
                  ignored_setting:
                    typeof data[0].ignored_setting == 'string'
                      ? JSON.parse(data[0].ignored_setting)
                      : data[0].ignored_setting
                }
              : {
                  page_id: this.selectedBot.pageid,
                  auto_training: false,
                  ignored: false,
                  spam: false,
                  max_score: 0.84,
                  min_score: 0.7,
                  ignored_setting: {
                    sticker: false,
                    location: false,
                    image: false,
                    audio: false,
                    video: false,
                    file: false
                  }
                }
        }
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Training/index.vue